export const COLLECTIONS_CREATE_REMIX_REQUEST =
  "API/ASSETS/COLLECTIONS/CREATE_REMIX";
export const COLLECTIONS_CREATE_REMIX_REQUEST_SUCCESS =
  "API/ASSETS/COLLECTIONS/CREATE_REMIX_SUCCESS";
export const COLLECTIONS_CREATE_REMIX_REQUEST_FAILURE =
  "API/ASSETS/COLLECTIONS/CREATE_REMIX_FAILURE";
